import ApiHelper from "../helper/ApiHelper";
import Constants from "../helper/Constants";

const statuses = {
  "0": "Ok",
  "1": "Preparing Revision"
};

const postRevisionStatuses = {
  "0": "Active",
  "1": "Insufficient Images",
  "2": "Preparing HTML",
  "3": "Rendered",
  "4": "Failed",
  "5": "Archive"
};

const ValidatePost = (postID) => {
  return new Promise((resolve, reject) => {
    const url = `me/posts/${postID}`;
    ApiHelper.getRequest(url)
      .then((res) => {
        if (res.status === 422) {
          reject(Constants.Post.MainErrorMessage.POST_DOESNT_EXIST);
        } else {
          const { status } = res.data.data;
          const { name } = res.data.data;

          const toReturn = {
            postName: name
          };

          const errorObj = {
            name,
            mainTitle: Constants.Post.MainErrorMessage.PENDING_POST
          };

          if (status === 0) {
            toReturn.message = Constants.Post.SuccessMessage.POST_LIVE;
            resolve(toReturn);
          }

          const { pending_revision } = res.data.data;

          if (pending_revision) {
            const pendingRevisionStatus = pending_revision.data.status;
            const pendingStatus = postRevisionStatuses[pendingRevisionStatus];
            errorObj.subTitle =
              Constants.Post.SecondaryErrorMessage.POST_NOT_LIVE;
            reject(errorObj);
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response);
          if (err.response.data.info === "ID not found for post") {
            const errorObj = {
              mainTitle: Constants.Post.MainErrorMessage.POST_DOESNT_EXIST
            };

            errorObj.subTitle =
              Constants.Post.SecondaryErrorMessage.POST_UNPUBLISHED;
            reject(errorObj);
          }
        }
        reject("Internal Server Error, Please try again");
      });
  });
};

export default ValidatePost;
